var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading2",style:({width: _vm.width, height: _vm.height})},[_c('img',{attrs:{"src":require("../../../assets/img/loading.gif"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }